import { Collapse, List, ListItem, ListItemText } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ITranslationWithDefault } from 'src/types'

import { useStyles } from './styles'

interface IGridItemCollapseProps {
  open: boolean
  item: ITranslationWithDefault
}

const GridItemCollapse = ({ open, item }: IGridItemCollapseProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="div" className={classes.collapseItemsWrapper}>
        {item.default?.value && (
          <ListItem disablePadding>
            <ListItemText
              primary={item.default?.value}
              secondary={t('translations-table-default-translation-column')}
            />
          </ListItem>
        )}
        <ListItem disablePadding>
          <ListItemText
            primary={item.value || '-'}
            secondary={t('translations-table-translation-column')}
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemText primary={item.type} secondary={t('type-translation-column')} />
        </ListItem>
      </List>
    </Collapse>
  )
}

export { GridItemCollapse }
